import React from 'react';
import ReactDOM from 'react-dom';
import App from './app/App';
import './index.css';
import * as firebase from 'firebase';

const config = {
  apiKey: "AIzaSyCn0wr_qmwoskdI5aSdwHkSF-HvPzgoiDk",
  authDomain: "portfolio-46be1.firebaseapp.com",
  databaseURL: "https://portfolio-46be1.firebaseio.com",
  storageBucket: "portfolio-46be1.appspot.com",
  messagingSenderId: "153779282036"
};

firebase.initializeApp(config);

ReactDOM.render(
  <App />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js